import React, { useState, useRef, forwardRef, useImperativeHandle, } from 'react';
import { Card, Row, Col, Form, DatePicker, Select } from 'antd';
import Input from '../../../../ui/Input';
import PageContainer from '../../../../CSIComponents/PageContainer';
import ApplicalbeDays from '../../../../CSIComponents/ApplicalbeDays';
import {Moment} from 'moment'
import moment from 'moment';

const Option = Select.Option;
interface propsTypes {
    // isEditable: void | any,
    // cancelEditable: void | any
    cancellationDetails: void | any,
    toggleToViewMode: void | any,
    setDetails: void | any,
    currentForm: void | any,
    setDateValidation: (e:boolean) => void
}
const FormItem = Form.Item;
const format = "MM/DD/YYYY"


const CancellationEdit = (props: propsTypes, parentRef: React.Ref<unknown> | undefined) => {
    const valueList = props.cancellationDetails.valueList;
    const applicalbeDaysRef = useRef({ resetData: () => { }, valueList })
    const [valueListAfterChanged, setValueListAfterChanged] = useState<{ title: string, value: boolean }>(valueList)

    const [startDateValidation, setStartDateValidation] = useState<"" | "error" | "success" | "warning" | "validating" | undefined>('')
    const [endDateValidation, setEndDateValidation] = useState<"" | "error" | "success" | "warning" | "validating" | undefined>('')

    const onChangeStartDate = (e: Moment | null) => {
        const enddate: Moment = props.currentForm.getFieldValue('enddate');
        if(!e){
            props.currentForm.setFieldsValue({['startdate']:''})
            if(enddate){ 
                setStartDateValidation('error');
                props.setDateValidation(false)
            } else { 
                setStartDateValidation('success');
                setEndDateValidation('success');
                props.setDateValidation(true)
            }
            return;
        }

        // props.currentForm.setFieldsValue({['startdate']:e});

        if(!enddate || e.unix() < enddate.unix()) {
            setStartDateValidation('success');
            setEndDateValidation('success');
            props.setDateValidation(true)
        } else {
            setStartDateValidation('error')
            props.setDateValidation(false)
        }
    }
    
    const onChangeEndDate = (e: Moment | null) => {
        const startdate: Moment = props.currentForm.getFieldValue('startdate');
        if(!e) {
            setEndDateValidation('success');
            setStartDateValidation('success')
            props.currentForm.setFieldsValue({['enddate']:''});
            props.setDateValidation(true)
            return;
        }

        props.currentForm.setFieldsValue({['enddate']:e})
        if(!startdate ) {
            setEndDateValidation('error');
            props.currentForm.setFields([{['enddate']:e, errors: ['error']}])
            props.setDateValidation(false)
        }
        else if(startdate.unix() < e.unix()) {
            setStartDateValidation('success')
            setEndDateValidation('success');
            props.setDateValidation(true)
        } else {
            setEndDateValidation('error')
            props.setDateValidation(false)
        }
    }

    useImperativeHandle(parentRef, () => {
        const refObj = {
            resetData: applicalbeDaysRef.current.resetData,
            valueList: valueListAfterChanged
        }
        return refObj
    })

    return (
        <PageContainer>
            <Card style={{ marginTop: -15 }} title={props.cancellationDetails?.policycode}>
                <div style={{ padding: "0 20px" }}>
                    <FormItem name="cancelid" style={{ display: 'none' }}>
                        <Input />
                    </FormItem>
                    <FormItem name="cancellangid" style={{ display: 'none' }}>
                        <Input />
                    </FormItem>
                    <FormItem name="deleteTitle" style={{ display: 'none' }}>
                        <Input />
                    </FormItem>
                    <Row gutter={24}>
                        <Col span={6} className="col-margin">
                            <FormItem
                                name="policycode"
                                label="Policy Code"
                                extra={(
                                    <span className="blue-font">
                                        Lanyon allows numeric characters only
                                    </span>
                                )}
                                rules={[{
                                    max: 16,
                                    message: 'You have reached the max character length of 16'
                                }]
                                }>
                                <Input maxLength={16}/>
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem 
                                name="startdate" 
                                label="Start Date"
                                hasFeedback
                                validateStatus={startDateValidation} 
                                help={startDateValidation === 'error' ? 'Start date can not be a future day or empty if end date is not' : ''}
                            >
                                <DatePicker format={format} onChange={onChangeStartDate} />
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem 
                                name="enddate" 
                                label="End Date"
                                hasFeedback
                                validateStatus={endDateValidation} 
                                help={endDateValidation === 'error' ? 'End date can not be a past date or start date is empty' : ''} 
                            >
                                <DatePicker format={format} onChange={onChangeEndDate} />
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={12} className="col-margin">
                            <ApplicalbeDays
                                label="Applicable Days of the Week"
                                valueList={props?.cancellationDetails?.valueList}
                                ref={applicalbeDaysRef}
                                readOnly={false}
                                originData={props?.cancellationDetails?.valueList}
                                setValueListAfterChanged={setValueListAfterChanged}
                            />
                        </Col>
                        <Col span={10}></Col>
                        <Col span={6} className="col-margin">

                            <FormItem name="roomtypecode" label="Applies to Room Type Code" rules={[{ max: 16, message: 'You have reached the max character length of 16' }]}>
                                <Input maxLength={16}/>
                            </FormItem>
                        </Col>
                        <Col span={6} className="col-margin">
                            <FormItem name="nonrefundable" label="Non-refundable">
                                <Select allowClear showSearch>
                                    <Option value="true">Yes</Option>
                                    <Option value="false">No</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                </div>
            </Card>
        </PageContainer>
    )
}

export default forwardRef(CancellationEdit);

